export interface IEmailEntityType {
    id: number;
    description: string;
}